import {
  Activity, ArrowLeftRight, BookOpen, Church, Database, DollarSign, FileText, FlaskConical,
  Globe, Handshake, Key, Search, Send, Settings, Undo2, Users,
} from 'lucide-react';

// Two rows: primary operations + admin/config.
const PRIMARY_TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: Activity },
  { id: 'merchants', label: 'Comercios', icon: Users },
  { id: 'ledger', label: 'Saldos', icon: BookOpen },
  { id: 'orders', label: 'Ordenes', icon: FileText },
  { id: 'transfers', label: 'Transferencias', icon: Send },
  { id: 'admin-transfer', label: 'Transf. Admin', icon: ArrowLeftRight },
  { id: 'expired-refunds', label: 'Refunds Expirados', icon: Undo2 },
  { id: 'payment-verifier', label: 'Verificador', icon: Search },
  { id: 'alliances', label: 'Alianzas', icon: Handshake },
  { id: 'congregations', label: 'Congregaciones', icon: Church },
  { id: 'commission-wallets', label: 'Comisiones', icon: DollarSign },
  { id: 'wallets', label: 'Wallets', icon: Database },
];

const SECONDARY_TABS = [
  { id: 'credentials', label: 'Credenciales', icon: Key },
  { id: 'api-connections', label: 'Conexiones API', icon: Globe },
  { id: 'production', label: 'Produccion', icon: Settings },
  { id: 'merchant-api-logs', label: 'API Comercios', icon: Activity },
  { id: 'sandbox', label: 'Sandbox', icon: FlaskConical },
  { id: 'logs', label: 'Logs del Sistema', icon: FileText },
];

function TabButton({ tab, active, onClick }) {
  const Icon = tab.icon;
  return (
    <button
      data-testid={`tab-${tab.id}`}
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2.5 border-b-2 transition-colors text-sm font-medium ${
        active ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'
      }`}
    >
      <Icon className="w-4 h-4" />{tab.label}
    </button>
  );
}

export default function SuperAdminTabs({ activeTab, setActiveTab }) {
  return (
    <div className="border-b bg-white" data-testid="superadmin-tabs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-1 border-b border-gray-100">
          {PRIMARY_TABS.map((t) => (
            <TabButton key={t.id} tab={t} active={activeTab === t.id} onClick={() => setActiveTab(t.id)} />
          ))}
        </div>
        <div className="flex gap-1">
          {SECONDARY_TABS.map((t) => (
            <TabButton key={t.id} tab={t} active={activeTab === t.id} onClick={() => setActiveTab(t.id)} />
          ))}
        </div>
      </div>
    </div>
  );
}
